import { Folder } from '../../types/folder.ts';
import { NewProject, Project } from '../../types/project.ts';
import { ProjectsState } from '../reducers/projects.reducer.ts';
import { RootState } from '../store.ts';

const getProjectsState = (state: RootState): ProjectsState => state.projects;

export const getProjectsSelector = (state: RootState): Project[] => getProjectsState(state).projects;
export const getExampleProjectsSelector = (state: RootState): Project[] => getProjectsState(state).exampleProjects;
export const getFolderSelector = (state: RootState): Folder | undefined => getProjectsState(state).folder;
export const getFolderTreeSelector = (state: RootState): Folder | undefined => getProjectsState(state).folderTree;
export const getNewProjectSelector = (state: RootState): NewProject => getProjectsState(state).newProject;
export const getCurrentProject = (state: RootState): Project | null => state.workspace.project;
export const getCurrentFolderId = (state: RootState): number | undefined => getProjectsState(state).currentFolderId;
export const getProjectsHasNext = (state: RootState): boolean => getProjectsState(state).hasNext;
export const getProjectsPage = (state: RootState): number => getProjectsState(state).page;
